(function ($, Drupal, once) {
  Drupal.behaviors.mapLocationButton = {
    attach(context) {
      once(
          'map-location-button',
          '.use-map-location',
          context
      ).forEach(function (button) {

        $(button).on('click', function (e) {
          e.preventDefault();

          const $mapButton = $('.geolocation-map-container .locate');

          // Trigger the existing Geolocation map button.
          if ($mapButton.length) {
            $mapButton.trigger('click');
          }

          // Check browser geolocation support.
          if (!navigator.geolocation) {
            console.warn(
                'Geolocation is not supported by this browser.'
            );
            return;
          }

          navigator.geolocation.getCurrentPosition(
              function (position) {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                console.log('Current location:', lat, lng);

                // Check Google Geocoder.
                if (
                    typeof google === 'undefined' ||
                    !google.maps ||
                    !google.maps.Geocoder
                ) {
                  console.warn(
                      'Google Geocoder is not available.'
                  );
                  return;
                }

                const geocoder = new google.maps.Geocoder();

                geocoder.geocode(
                    {
                      location: {
                        lat: lat,
                        lng: lng
                      }
                    },
                    function (results, status) {
                      if (
                          status !== 'OK' ||
                          !results.length
                      ) {
                        console.warn(
                            'Geocoding failed:',
                            status
                        );
                        return;
                      }

                      // Prefer the plus_code result.
                      const plusCodeResult = results.find(
                          function (result) {
                            return (
                                result.types &&
                                result.types.includes('plus_code')
                            );
                          }
                      );

                      if (!plusCodeResult) {
                        console.warn(
                            'No plus_code result found.'
                        );
                        return;
                      }

                      const address =
                          plusCodeResult.formatted_address;

                      console.log(
                          'Selected address:',
                          address
                      );

                      // Find address input.
                      const $addressInput = $(
                          'input[name*="geolocation_geocoder_address"]'
                      );

                      if (!$addressInput.length) {
                        console.warn(
                            'Address input not found.'
                        );
                        return;
                      }

                      const $form =
                          $addressInput.closest('form');

                      if (!$form.length) {
                        console.warn(
                            'Form not found.'
                        );
                        return;
                      }

                      // Set address.
                      $addressInput
                      .val(address)
                      .trigger('input')
                      .trigger('change');

                      // Set latitude.
                      $form
                      .find('input[name*="[lat]"]')
                      .val(lat)
                      .trigger('change');

                      // Set longitude.
                      $form
                      .find('input[name*="[lng]"]')
                      .val(lng)
                      .trigger('change');

                      console.log(
                          'Address:',
                          address
                      );
                      console.log(
                          'Latitude:',
                          lat
                      );
                      console.log(
                          'Longitude:',
                          lng
                      );

                      /*
                       * Trigger the normal BEF Search button.
                       * This keeps the request inside Drupal's
                       * AJAX form handling.
                       */
                      const $searchButton = $form.find(
                          'input[type="submit"], button[type="submit"]'
                      ).filter(function () {
                        return $(this).is(':visible');
                      }).first();

                      if (!$searchButton.length) {
                        console.warn(
                            'Search button not found.'
                        );
                        return;
                      }

                      console.log(
                          'Triggering BEF search button.'
                      );

                      $searchButton.trigger('mousedown');
                      $searchButton.trigger('mouseup');
                      $searchButton.trigger('click');
                    }
                );
              },
              function (error) {
                console.warn(
                    'Unable to get current location.',
                    error
                );
              },
              {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0
              }
          );
        });
      });
    }
  };
})(jQuery, Drupal, once);